import { GraphItemType } from 'features/dashBoard/types'
import Dexie, { Table, IndexableType } from 'dexie'
export { useLiveQuery } from 'dexie-react-hooks'

export interface KeepSisetu {
  id?: IndexableType
  userId: number
  sisetuCode: string
  sisetuName: string
}

export interface DashBoardItem {
  size?: 'small' | 'midium' | 'large' | 'wide' | 'extra'    // 古いバージョンのデータをサポート
  width?: 'small' | 'midium' | 'large' | 'extra' | number   // 古いバージョンのデータをサポート
  height?: 'small' | 'midium' | 'large' | 'extra' | number  // 古いバージョンのデータをサポート
  x?: number
  y?: number
  title?: string
  graphType?: GraphItemType
  options?: {
    id: string
    value: string
  }[]
}
export interface DashBoard {
  boardId?: string // userId-boardName
  profileId?: number
  items?: DashBoardItem[]
  globalAxisKey?: string
}

export type KojinListTargetTypes = 'extend' | 'target' | 'all'
export type DownloadFormatTypes = 'csv' | 'tsv' | 'excel' | 'report' | 'pptx'

export interface KojinListDownloadParams {
  userId: number
  target: KojinListTargetTypes
  format: DownloadFormatTypes
  reportId: string | null
  columns: string[]
}

export class InsiteDexieDB extends Dexie {
  keepSisetu!: Table<KeepSisetu>
  dashBoard!: Table<DashBoard>
  kojinListDownloadParams!: Table<KojinListDownloadParams>

  constructor() {
    super('insite')
    this.version(1).stores({
      // Primary key and indexed props,
      keepSisetu: 'id++, userId, sisetuCode',
      dashBoard: 'boardId',
      kojinListDownloadParams: 'userId',
    })
  }
}
export const indexedDB = new InsiteDexieDB()
